import { findRecord } from "./services.js";
import { toJalaali } from "jalaali-js";

async function getFactorDetail(factor_id) {
  let res = await findRecord("factors", {
    conditions: `id/=/${factor_id}`,
    fields: "mtm, type, main_status, (total_amt - total_paid) as pay_state",
  });
  if (res.length == 0) return false;
  let date;
  try {
    date = toJalaali(new Date(parseInt(res[0].mtm) * 1000));
    date = `${date.jy}/${date.jm < 10 ? "0" : ""}${date.jm}/${date.jd < 10 ? "0" : ""}${date.jd}`;
  } catch (err) {
    // console.log(res[0]);
    // console.log(err);
  }
  return {
    type: parseInt(res[0].type),
    date,
    main_status: parseInt(res[0].main_status),
    pay_state: parseInt(res[0].pay_state) > 0 ? 0 : 1,
  };
}

async function getOrders(factor_id) {
  let res,
    data = [
      {
        title: "",
        total_count: 0,
        total_discount: 0,
        total_amt: 0,
        total_paid: 0,
        passangers: [{ id: -1, fname: "", lname: "", mobile: "" }],
      },
    ];
  res = await findRecord("factors", {
    conditions: `id/=/${factor_id}`,
    fields: "type, total_count, total_discount, total_amt, total_paid",
  });
  if (res.length == 0) return false;
  let { type } = res[0];
  switch (parseInt(type)) {
    case 0:
      let d = {
        total_count: res[0].total_count,
        total_discount: res[0].total_discount,
        total_amt: res[0].total_amt,
        total_paid: res[0].total_paid,
      };

      res = await findRecord("tour_reservation_items", {
        tbl_name: "tours",
        conditions: `tour_reservation_items.factor_id/=/${factor_id}`,
        fields: "tour_reservation_items.id, tour_reservation_items.uid, tours.title",
      });
      if (res.length == 0) return false;
      d.title = res[0].title;

      let userIds = res.map((value) => value.uid);
      res = await findRecord("users", {
        conditions: `id/in/${userIds.join(",")}`,
        fields: "id, fname, lname, mobile",
      });
      d.passangers = res.map((value) => value);
      data = [d];
      break;
    default:
      console.log("Not Yet!!");
  }
  return data;
}

async function getTransactions(factor_id) {
  let res = await findRecord("wallets_transactions", {
    conditions: `factor_id/=/${factor_id}`,
    fields: "amount, main_status, mtm",
  });
  let data = res.map((value) => {
    let date;
    try {
      date = toJalaali(new Date(parseInt(value.mtm) * 1000));
      date = `${date.jy}/${date.jm < 10 ? "0" : ""}${date.jm}/${date.jd < 10 ? "0" : ""}${date.jd}`;
    } catch (err) {
      console.log(value);
      console.log(err);
    }
    return {
      amount: parseInt(value.amount),
      date,
      main_status: parseInt(value.main_status),
    };
  });
  return data;
}

export { getFactorDetail, getOrders, getTransactions };
